import {cn} from "@/lib/utils";
import {LucideIcon, Share2} from "lucide-react";
import {forwardRef} from "react";

export const InfluenceMapIcon: LucideIcon = forwardRef(({className, ...props}) => (
  <Share2 {...props} className={cn("rotate-90", className)} />
));

InfluenceMapIcon.displayName = "InfluenceMapIcon";
